import { createFileRoute } from '@tanstack/react-router'
import { DLQMonitor } from '../../../../features/admin/DLQMonitor'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/pipeline/dlq')({
  component: AdminPipelineDLQRoute,
})

/* ───── Route Component ───── */

function AdminPipelineDLQRoute() {
  return <DLQMonitor />
}
